if(!customElements.get('hero-carousel')) {
  class ComponentHeroCarousel extends HTMLElement {
    constructor() {
      super();
      this.swiperEl = this.querySelector('.swiper');
      this.slidesWrapper = this.querySelector('.swiper-wrapper');
      this.slides = this.slidesWrapper.children;
      this.effect = this.dataset.effect;
      this.autoplaySeconds = parseFloat(this.dataset.autoplay) || 0;
      this.pauseOnHover = this.dataset.pauseOnHover!=='false';
      this.carousel = false;
      this.isInViewPort = false;

      const start = () => {
        setTimeout(()=>{ //The timeout is for the customizer
          this.initVideos();
          this.initCarousel();
        }, 1);

        this.bindCustomizerEvents();
      };

      if(window.Swiper) { start(); }
      else { window.addEventListener('swiper:ready', start); }
    }

    initVideos() {
      if(this.hasVideos()) {
        this.updateVideos();

        this.slidesWrapper.querySelectorAll('.play').forEach((button)=>{
          button.addEventListener('click', ()=>{
            this.playVideo(button.closest('.video-wrap').querySelector('video'));
          });
        });
        this.slidesWrapper.querySelectorAll('.pause').forEach((button)=>{
          button.addEventListener('click', ()=>{
            this.pauseVideo(button.closest('.video-wrap').querySelector('video'));
          });
        });
        window.addEventListener('mediaChange', ()=>{this.updateVideos()});

        window.addEventListener('scroll', $s.throttle(()=>{
          let _isInViewPort = $s.isInViewport(this.slidesWrapper);
          if(_isInViewPort!=this.isInViewPort) {
            this.updateVideos();
          }
        }, 500));
      }
    }

    updateVideos() {
      this.isInViewPort = $s.isInViewport(this.slidesWrapper);

      var currentSlide = this.getCurrentSlide();
      if(this.isInViewPort) {
        this.loadVideos(currentSlide);
        if(this.carousel) {
          this.slidesWrapper.querySelectorAll("video").forEach((video)=>{
            this.pauseVideo(video);
          });
        }
        currentSlide.querySelectorAll('video').forEach((video)=>{
          if($s.isVisible(video)) {
            this.playVideo(video);
          }
        });
      } else {
        currentSlide.querySelectorAll('video').forEach((video)=>{
          if($s.isVisible(video)) {
            this.pauseVideo(video);
          }
        });
      }
    }

    hasVideos() {
      return this.slidesWrapper.querySelectorAll('video').length > 0;
    }

    loadVideos(slide) {
      slide.querySelectorAll('video').forEach((video)=>{
        if($s.isVisible(video) && !video.dataset.initialized) {
          var source = video.querySelector('source');
          source.setAttribute('src', source.dataset.src);
          video.dataset.initialized = true;
          video.load();
        }
      });
    }

    playVideo(video) {
      if(video) {
        let videoWrap = video.closest('.video-wrap');
        $s.playMedia(video);
        videoWrap.querySelector('.play').classList.add('hide');
        videoWrap.querySelector('.pause').classList.remove('hide');
      }
    }

    pauseVideo(video) {
      if(video) {
        let videoWrap = video.closest('.video-wrap');
        $s.pauseMedia(video);
        videoWrap.querySelector('.play').classList.remove('hide');
        videoWrap.querySelector('.pause').classList.add('hide');
      }
    }

    initCarousel() {
      const updateSlideAccessibility = () => {
        Array.from(this.slides).forEach((slide) => {
          const isActive = slide.classList.contains('swiper-slide-active');
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          // Set tabindex on all focusable elements inside the slide
          const focusableSelector = 'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])';
          slide.querySelectorAll(focusableSelector).forEach(el => {
            if (isActive) {
              if (el.getAttribute('data-prev-tabindex') !== null) {
                el.setAttribute('tabindex', el.getAttribute('data-prev-tabindex'));
                el.removeAttribute('data-prev-tabindex');
              } else {
                el.removeAttribute('tabindex');
              }
            } else {
              if (el.hasAttribute('tabindex')) {
                el.setAttribute('data-prev-tabindex', el.getAttribute('tabindex'));
              }
              el.setAttribute('tabindex', '-1');
            }
          });
        });
      };

      if(this.slides.length > 1) {
        var options = {
          slidesPerView: 1,
          a11y: { enabled: false }, // custom updateSlideAccessibility drives this
        };
        // Swiper's loop needs enough slides to clone; with <=2 (slidesPerView 1) it
        // fails to create clones and stalls (autoplay/nav stop). Use rewind for small
        // counts so it still cycles; seamless loop only when there are enough slides.
        // Loop clones duplicate <video> DOM (the clone's play/pause controls aren't wired and
        // active-slide detection can land on a clone), so use rewind when the hero has videos.
        if(this.slides.length > 2 && !this.hasVideos()) { options.loop = true; }
        else { options.rewind = true; }

        if(this.effect == 'fade') {
          options.effect = 'fade';
          options.fadeEffect = { crossFade: true };
        }

        var dotsEl = this.querySelector('.keen-dots');
        if(dotsEl) {
          options.pagination = { el: dotsEl, clickable: true };
        }

        var prevEl = this.querySelector('.keen-arrow.prev');
        var nextEl = this.querySelector('.keen-arrow.next');
        if(prevEl && nextEl) {
          options.navigation = { prevEl: prevEl, nextEl: nextEl };
        }

        if(this.autoplaySeconds > 0) {
          options.autoplay = {
            delay: this.autoplaySeconds * 1000,
            disableOnInteraction: false,
            pauseOnMouseEnter: this.pauseOnHover
          };
        }

        var self = this;
        options.on = {
          init: function () { updateSlideAccessibility(); },
          slideChange: function () {
            updateSlideAccessibility();
            if(self.hasVideos()) {
              self.updateVideos();
            }
          }
        };

        this.carousel = new Swiper(this.swiperEl, options);
      } else {
        this.swiperEl.classList.add('initialized');
      }
    }

    getCurrentSlide() {
      if(this.carousel) {
        var active = this.swiperEl.querySelector('.swiper-slide-active');
        if(active) {
          return active;
        }
      }
      return this.slides[0];
    }

    bindCustomizerEvents() {
      if(Shopify.designMode) {
        this.addEventListener('shopify:block:select', (e)=>{
          let index = Array.from(this.slides).findIndex(x=>x==e.target);
          if(index>=0 && this.carousel) {
            setTimeout(()=>{
              this.carousel.slideToLoop(index, 0)
            }, 10);
          }
        });
      }
    }
  }
  customElements.define('hero-carousel', ComponentHeroCarousel);
}
